import { render, staticRenderFns } from "./KonvaCampaignStage.vue?vue&type=template&id=71d8701e&scoped=true"
import script from "./KonvaCampaignStage.vue?vue&type=script&lang=js"
export * from "./KonvaCampaignStage.vue?vue&type=script&lang=js"
import style0 from "./KonvaCampaignStage.vue?vue&type=style&index=0&id=71d8701e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8701e",
  null
  
)

export default component.exports